import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class DenyNonStaffService implements CanActivate  {

  private _lastCheck: number;

  private _sendToTablet(): Observable<boolean> {
    this._router.navigateByUrl('/remnants');
    return Observable.of(false);
  }

  constructor(private _router: Router, private _auth: AuthService) { }

  canActivate(): Observable<boolean> {

    let user = this._auth.getUser();
    if(user.role == "Non-Staff") {
      this._router.navigateByUrl('/remnants');
      return Observable.of(false);
    }
    return Observable.of(true);

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/deny-non-staff.service.ts